<cs-card-list>
  <!-- Macro Targets Card -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.nutritionOptions.macroTargets() }}
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="nutritionCoachingOn" (selectedChange)="handleNutritionToggleChanged()">
        <cs-radio [value]="true" [recommended]="true">
          {{ LL.intake.nutritionOptions.enabled() }}
          <cs-note>{{ LL.intake.nutritionOptions.enabledNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="false">
          {{ LL.intake.nutritionOptions.disabled() }}
          <cs-note>{{ LL.intake.nutritionOptions.disabledNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>

  <!-- Macro Tracking Card -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.nutritionOptions.macroTracking() }}
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="nutritionTrackingOn" (selectedChange)="handleNutritionToggleChanged()">
        <cs-radio [value]="true" [recommended]="true">
          {{ LL.intake.nutritionOptions.trackInApp() }}
          <cs-note>{{ LL.intake.nutritionOptions.trackInAppNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="false">
          {{ LL.intake.nutritionOptions.trackElsewhere() }}
          <cs-note>{{ LL.intake.nutritionOptions.trackElsewhereNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>

  <!-- Tracking Type Card -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.nutritionOptions.trackingType() }}
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="macroTargetsFlexible" (selectedChange)="handleNutritionToggleChanged()">
        <cs-radio [value]="true" [recommended]="true">
          {{ LL.intake.nutritionOptions.flexibleNutrition() }}
          <cs-note>{{ LL.intake.nutritionOptions.flexibleNutritionNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="false">
          {{ LL.intake.nutritionOptions.fixedTargets() }}
          <cs-note>{{ LL.intake.nutritionOptions.fixedTargetsNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>

  <!-- Calorie Cycling Card -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.advanced.calorieCycling() }}
      <cs-tooltip large iconType="info">
        {{ LL.intake.advanced.calorieCyclingTooltip() }}
        <help-link helpId="@help:intake.advanced-training-techniques-calorie-cycling">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="state.advancedMethodsCalorieCycling"
        (selectedChange)="handleCalorieCyclingChange()">
        <cs-radio [value]="true">
          {{ LL.intake.advanced.calorieCyclingOn() }}
          <cs-note>{{ LL.intake.advanced.calorieCyclingOnNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="false">
          {{ LL.intake.advanced.calorieCyclingOff() }}
          <cs-note>{{ LL.intake.advanced.calorieCyclingOffNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>
</cs-card-list>